import { useState } from "react";
import { Dialog } from "../design/Dialog";
import { Status } from "../design/Hinweis";
import { Kachel, Knopf } from "../design/Kachel";
import { iphoneOhneHomeBildschirm } from "./geraet";

export const WORTLAUT_IPHONE_OHNE_HOME_BILDSCHIRM =
  "Benachrichtigungen kommen auf dem iPhone nur an, wenn die App auf dem Home-Bildschirm liegt.";

/**
 * Hinweis für das iPhone ohne Home-Bildschirm (oberflaeche.md §7, §9; LIM-0005): `status` mit dem festen Wortlaut und
 * `button` „Anleitung“, der zeigt, wie die App auf den Home-Bildschirm kommt. Ohne Ansprache und Anredepronomen
 * (§2.3), weil er auch in Ansichten ohne Revierbezug steht. Auf anderen Geräten erscheint nichts.
 */
export function IphoneHinweis() {
  const [offen, setOffen] = useState(false);
  if (!iphoneOhneHomeBildschirm()) return null;
  return (
    <>
      <Status symbol="benachrichtigungen" aktion={<Kachel symbol="anleitung" begriff="Anleitung" art="kompakt" onPress={() => setOffen(true)} />}>
        {WORTLAUT_IPHONE_OHNE_HOME_BILDSCHIRM}
      </Status>
      <Dialog name="Anleitung" symbol="anleitung" offen={offen} onSchliessen={() => setOffen(false)}>
        <ol className="anleitung">
          <li>In Safari unten auf „Teilen“ tippen.</li>
          <li>„Zum Home-Bildschirm“ wählen und mit „Hinzufügen“ bestätigen.</li>
          <li>Die App vom Home-Bildschirm aus öffnen, anmelden und Benachrichtigungen erlauben.</li>
        </ol>
        <div className="knopfreihe">
          <Knopf symbol="schliessen" onPress={() => setOffen(false)}>Schließen</Knopf>
        </div>
      </Dialog>
    </>
  );
}
